/*
================================================================ 
         Copyright (c) 2018-2020 Digitize Things Inc.           
                     All rights reserved.                       
================================================================ 
*/
import React, { Component } from "react";
import AuthService from "./authService";
import { connect } from "react-redux";
import actionTypes from "../store/actions";
import Loader from "../component/loader";
import BusApiCall from "../helper/axios.js";
import constants from "../helper/constants";
import store from "../store/store";
import { getAppDomain } from "../helper/getAppDomain.js";
import LogoutHelper from "../helper/logoutHelper.js";
import { withNavigation } from "../helper/withNavigation";
class Callback extends Component {
  safeTrim = (value) => {
    if (value == null) return ''; // handles null & undefined
    if (typeof value === 'string') return value.trim();
    if (typeof value === 'number') return String(value);
    if (typeof value === 'boolean') return value;
    if (Array.isArray(value)) return value.join(', ').trim();
    if (typeof value === 'object') return JSON.stringify(value).trim();
    return '';
  }
  componentDidMount() {
    this.props.setCompDidMount();
    let search = new URLSearchParams(this.props.router.location.search);
    var sp = search.get("sp");
    if (sp) {
      this.props.router.navigate("/");
    }
    var absoluteDomain = getAppDomain() || "";
    if (window.self === window.top) {
      // if (searchParams.get('code')) {
      AuthService.signinRedirectCallback()
        .then((a) => {
          this.props.authenticate(a);
          if (a) {
            localStorage.setItem("tokenInfo", JSON.stringify(a));
            BusApiCall(
              "GET",
              `${constants.busInternalUrl}/loggedInUserPermission`,
            )
              .then((userRoles) => {
                if (
                  window.location.protocol === "https:" ||
                  window.location.protocol === "HTTPS:"
                ) {
                  document.cookie =
                    "user_login_id=" +
                    userRoles.data.loggedInUser.userId +
                    "; domain=" +
                    absoluteDomain +
                    "; path=/; secure;";
                  document.cookie =
                    "tenantId=" +
                    userRoles.data.tenantId +
                    "; domain=" +
                    absoluteDomain +
                    "; path=/; secure;";
                  document.cookie =
                    "sharedToken=true; domain=" +
                    absoluteDomain +
                    "; path=/; secure;";
                  document.cookie =
                    "tenantInfo=" +
                    JSON.stringify(this.props.tenantInfo) +
                    "; domain=" +
                    absoluteDomain +
                    "; path=/; secure;";
                } else {
                  document.cookie =
                    "user_login_id=" +
                    userRoles.data.loggedInUser.userId +
                    "; domain=" +
                    absoluteDomain +
                    "; path=/;";
                  document.cookie =
                    "tenantId=" +
                    userRoles.data.tenantId +
                    "; domain=" +
                    absoluteDomain +
                    "; path=/;";
                  document.cookie =
                    "sharedToken=true; domain=" + absoluteDomain + "; path=/;";
                  document.cookie =
                    "tenantInfo=" +
                    JSON.stringify(this.props.tenantInfo) +
                    "; domain=" +
                    absoluteDomain +
                    "; path=/;";
                }
                localStorage.removeItem("preSelectedCustomer");
                localStorage.removeItem("preSelectedPaymentMethod");
                localStorage.setItem("roles", JSON.stringify(userRoles));
                localStorage.setItem(
                  "modules",
                  JSON.stringify(userRoles.data.modules),
                );
                this.props.setDefaultCountry(userRoles.data.defaultCountry || "USA");
                this.props.setEnabledFeatures(userRoles.data.features || {});
                this.props.setModules(userRoles.data.modules);
                let tenantId = userRoles.data.tenantId;
                if (userRoles.data.locale) {
                  this.props.setTenantLocale(userRoles.data.locale.trim());
                }

                this.props.setPublicBrowsing(false);

                let sol = this.props.solutionList;

                for (var i = 0; i < sol.length; i++) {
                  if (!sol[i].tenantId) {
                    sol[i].tenantId = tenantId;
                  }
                }
                if (sol.length > 0) {
                  this.props.clearCart();
                  // Commenting out below line as it is adding one item to cart after login.
                  // So causing a issue if user adds more then one item without login
                  // Also there is no comment why we were doing this.
                  // So in case we saw any issue. Plese fix it considering the above case.
                  // this.props.addToCart(sol[0], []);

                  // Adding all solutions to cart.
                  for (var i = 0; i < sol.length; i++) {
                    this.props.addToCart(sol[i], []);
                  }
                }

                for (var i = 0; i < userRoles.data.securityGroups.length; i++) {
                  if (
                    userRoles.data.securityGroups[i].securityGroup.includes(
                      "ECOMMERCE_CUSTOMER",
                    ) ||
                    userRoles.data.securityGroups[i].securityGroup.includes(
                      "ECOMMERCE_ADMIN",
                    )
                  ) {
                    BusApiCall(
                      "GET",
                      `${constants.busV4Url}/myProfile?customerId=`,
                    ).then((res) => {
                      this.props.setEcommerceCustData(res.data);
                    });
                    break;
                  }
                }
                // BusApiCall('GET', `${constants.busV4Url}/myProfile?customerId=`).then(res => {
                //     this.props.setEcommerceCustData((res.data))
                // })
                if (
                  userRoles.data.loggedInUser.permissions.includes(
                    "CUMULATOR-REPORT_VIEW",
                  )
                ) {
                  BusApiCall(
                    "GET",
                    `${constants.genericReportUrl}?reportName=${"getAvailableReports"}`,
                  ).then((res) => {
                    if (
                      res.data &&
                      res.data.reportDataJson &&
                      res.data.reportDataJson.reportData
                    ) {
                      this.props.setGenericReports(
                        res.data.reportDataJson.reportData,
                      );
                    } else {
                      this.props.setGenericReports([]);
                    }
                  });
                } else {
                  this.props.setGenericReports([]);
                }
                BusApiCall(
                  "GET",
                  `${constants.busInternalUrl}/tenants/${tenantId}/themes`,
                )
                  .then((salesChannelData) => {
                    BusApiCall(
                      "GET",
                      `${constants.busV44UrlPublic}/tenant/${tenantId}/currency`,
                    ).then((currency) => {
                      localStorage.setItem(
                        "tenantCurrency",
                        JSON.stringify(currency.data),
                      );
                    });
                    var tenantDataTemp = JSON.parse(
                      localStorage.getItem("roles"),
                    );
                    var payload = {
                      partyId: tenantDataTemp.data.loggedInUser.partyId
                        ? tenantDataTemp.data.loggedInUser.partyId
                        : "",
                    };
                    BusApiCall(
                      "POST",
                      `${constants.busInternalUrl}/passthru/GET_PENDING_TASKS_COUNT/endpoint`,
                      payload,
                    )
                      .then((res) => {
                        this.props.setPendingTaskCount(
                          res.data.pendingTasksCount,
                        );
                      })
                      .catch((err) => {
                        // if (err.response && err.response.data && err.response.data.message) {
                        //     this.props.setErrorMessage(err.response.data.message, false);
                        // } else {
                        //     this.props.setErrorMessage(this.props.t("DEFAULT_ERROR_MESSAGE"), false);
                        // }
                      });
                    var tempThemeData = {
                      data: [],
                    };
                    tempThemeData.data = salesChannelData.data.map((item) => ({
                      ...item,
                      value: this.safeTrim(item.value),
                    }));
                    let tenantData = {};
                    for (var i = 0; i < salesChannelData.data.length; i++) {
                      tenantData[salesChannelData.data[i].key] = this.safeTrim(
                        salesChannelData.data[i].value,
                      );
                    }
                    localStorage.setItem(
                      "themeData",
                      JSON.stringify(tempThemeData),
                    );
                    if (tenantData["menuOrientation"]) {
                      if (
                        tenantData["menuOrientation"].toLowerCase() === "top"
                      ) {
                        localStorage.setItem("sideMenu", false);
                        localStorage.setItem("showBucketsOnLeft", false);
                        this.props.setSideMenu(false);
                      } else {
                        localStorage.setItem("sideMenu", true);
                        localStorage.setItem("showBucketsOnLeft", true);
                        this.props.setSideMenu(true);
                      }
                    } else {
                      localStorage.setItem("sideMenu", true); //fallback value incase menuorientaion key is missing is on the Left
                      localStorage.setItem("showBucketsOnLeft", true);
                      this.props.setSideMenu(true);
                    }
                    if (tenantData["showMyCustomerEnabled"]) {
                      localStorage.setItem(
                        "showMyCustomerEnabled",
                        tenantData["showMyCustomerEnabled"] === true ||
                          tenantData["showMyCustomerEnabled"] === "true"
                          ? "true"
                          : "false",
                      );
                    } else {
                      localStorage.setItem("showMyCustomerEnabled", "false");
                    }

                    // localStorage.setItem('sideMenu', false);
                    // localStorage.setItem('showBucketsOnLeft', false);

                    this.props.setTenantData(tenantData);
                    let finalRes = {
                      ...a,
                      userRoles: { ...userRoles },
                    };
                    this.props.authenticate(finalRes);
                    this.props.setTenantId(tenantId);
                    var redirectUrl = localStorage.getItem("redirectUrl");
                    if (redirectUrl && redirectUrl.includes("viewSolution/")) {
                      this.props.router.navigate("/product");
                    } else {
                      if (redirectUrl && redirectUrl.includes("signUp")) {
                        this.props.router.navigate("/");
                      } else {
                        if (redirectUrl) {
                          this.props.router.navigate(redirectUrl);
                        } else {
                          this.props.router.navigate("/");
                        }
                      }
                    }
                  })
                  .catch((error) => {
                    console.log("error sales channel", error);
                  });
              })
              .catch((error) => {
                if (
                  error &&
                  error.response &&
                  (error.response.status === 500 ||
                    error.response.status === 401 ||
                    error.response.status === 404)
                ) {
                  console.log("check error 500/401/404", error.response.data);
                  if (error.response.status === 404) {
                    this.props.setErrorMessage(
                      "Your account does not exists in IoT Platform. Please setup user account and try again. Redirecting to the login page",
                      false,
                    );
                  } else if (error.response.status === 401) {
                    this.props.setErrorMessage(
                      error.response.data.message,
                      false,
                    );
                  } else {
                    this.props.setErrorMessage(
                      error.response.data.message,
                      false,
                    );
                  }
                  document.querySelector(
                    ".init-app-global-loader",
                  ).style.backgroundColor = "white";
                  setTimeout(() => {
                    LogoutHelper();
                    // var Cookies = document.cookie.split(';');
                    // for (var i = 0; i < Cookies.length; i++) {
                    //     if (window.location.protocol === 'https:' || window.location.protocol === 'HTTPS:') {
                    //         document.cookie = Cookies[i].split('=')[0] + "=; path=/; domain=" + absoluteDomain + "; secure; expires=" + new Date(0).toUTCString();
                    //     } else {
                    //         document.cookie = Cookies[i].split('=')[0] + "=; path=/; domain=" + absoluteDomain + ";  expires=" + new Date(0).toUTCString();
                    //     }
                    // }
                    // localStorage.clear();
                    // sessionStorage.clear();
                    // window.location.href = '/login';
                  }, 5000);

                  // var Cookies = document.cookie.split(';');
                  // for (var i = 0; i < Cookies.length; i++) {
                  //     if (window.location.protocol === 'https:' || window.location.protocol === 'HTTPS:') {
                  //         document.cookie = Cookies[i].split('=')[0] + "=; path=/; domain=" + absoluteDomain + "; secure; expires=" + new Date(0).toUTCString();
                  //     } else {
                  //         document.cookie = Cookies[i].split('=')[0] + "=; path=/; domain=" + absoluteDomain + ";  expires=" + new Date(0).toUTCString();
                  //     }
                  // }

                  // localStorage.clear();
                  // AuthService.signoutRedirect();
                }
              });
          } else {
            this.props.router.navigate("/");
          }
        })
        .catch((e) => {
          // console.log('check auth service error', e.message);
          this.props.router.navigate("/");
        });
      // } else {
      //     this.props.router.navigate('/')
      // }
    }
  }

  render() {
    return <Loader loading={true} top={"40%"} />;
  }
}

const mapStateToProps = (state) => {
  return {
    authenticated: state.auth.authenticated,
    publicBrowsing: state.auth.publicBrowsing,
    solutionList: state.cart.solutions,
    tenantInfo: state.auth.tenantInfo,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    authenticate: (profile) =>
      dispatch({ type: actionTypes.AUTHENTICATE, profile }),
    singOut: () => dispatch({ type: actionTypes.SIGN_OUT }),
    setCompDidMount: () =>
      dispatch({ type: actionTypes.GLOBAL_COMP_DID_MOUNT }),
    setTenantId: (id) => dispatch({ type: actionTypes.SET_TENANT_ID, id }),
    setTenantData: (data) =>
      dispatch({ type: actionTypes.SET_TENANT_DATA, data }),
    setTenantLocale: (locale) =>
      dispatch({ type: actionTypes.SET_TENANT_LOCALE, locale }),
    setEcommerceCustData: (data) =>
      dispatch({ type: actionTypes.ECOMMERCE_CUST_DATA, data }),
    setPublicBrowsing: (data) =>
      dispatch({ type: actionTypes.SET_PUBLIC_BROWSING, data }),
    addToCart: (sol, acc) =>
      dispatch({ type: actionTypes.ADD_TO_CART, sol, acc }),
    clearCart: () => dispatch({ type: actionTypes.CLEAR_CART }),
    setGenericReports: (data) =>
      dispatch({ type: actionTypes.SET_GENERIC_REPORTS, data }),
    setPendingTaskCount: (data) =>
      dispatch({ type: actionTypes.SET_PENDING_TASK_COUNT, data }),
    setModules: (data) => dispatch({ type: actionTypes.SET_MODULES, data }),
    setSideMenu: (data) => dispatch({ type: actionTypes.SET_SIDE_MENU, data }),
    setErrorMessage: (errMsg, msgType, warning) =>
      dispatch({ type: actionTypes.SET_ERROR_MSG, errMsg, msgType, warning }),
    setDefaultCountry: (data) => dispatch({ type: actionTypes.SET_DEFAULT_COUNTRY, data }),
    setEnabledFeatures: (data) => dispatch({ type: actionTypes.SET_ENABLED_FEATURES, data }),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withNavigation(Callback));
